/* Connie — comportamenti minimi. Niente framework, niente dipendenze. */
(function () {
  'use strict';

  /* FAQ: apri/chiudi */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.cn-faq__q');
    if (!q) return;
    var item = q.closest('.cn-faq__item');
    var open = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', open ? 'false' : 'true');
    q.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* Selettore a livelli: aggiorna il testo del bottone */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.cn-tier input')) return;
    var form = e.target.closest('.cn-tiers-form');
    if (!form) return;
    var btn = form.querySelector('.cn-tiers__submit');
    var label = e.target.getAttribute('data-cta');
    if (btn && label) btn.textContent = label;
  });

  /* Una sola animazione: le sezioni entrano da sotto. Rispetta reduced-motion. */
  if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.cn-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.cn-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
